<template>
  <div>
    <el-transfer
      v-model="companyId"
      style="margin-bottom: 20px;"
      filterable
      :filter-method="filterMethod"
      :titles="['公司列表', '已选公司列表']"
      filter-placeholder="请输入公司名称"
      :data="companyList"
      :props="{key: 'value'}"
      @change="handleChange"
    />
    <el-transfer
      v-model="transferValue"
      filterable
      :filter-method="filterMethod"
      :titles="['人员列表', '已选人员列表']"
      filter-placeholder="请输入名称"
      :data="peopleList"
      :props="{key: 'value'}"
    />
  </div>
</template>

<script>
import { getOdooCompany } from '@/api/systemNotice';
import { controlPage } from '@/api/userControl';

export default {
  name: 'TransferSelect',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      peopleList: [],
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      companyId: [],
      companyList: [],
    };
  },
  computed: {
    transferValue: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  created() {
    this.fetchCompanyData();
    if (this.transferValue && this.transferValue.length) {
      this.companyId = this.transferValue.map((item) => {
        const arr = item.split('||');
        return arr[arr.length - 2];
      });
      this.companyId = Array.from(new Set(this.companyId));
      this.fetchData(this.companyId, true);
    }
  },
  methods: {
    async fetchCompanyData(query) {
      this.loading = true;
      const result = await getOdooCompany({ name: query });
      this.loading = false;
      this.companyList = result.map((v) => ({
        companyId: v.id, companyName: v.name, value: `${v.id}`, label: v.name,
      }));
    },
    handleChange(val) {
      if (val && val.length) {
        this.fetchData(val);
      } else {
        this.transferValue = [];
        this.peopleList = [];
      }
    },
    async fetchData(companyIds = []) {
      const params = {
        page: 1,
        size: 100000,
        sort: 'update_time__DESC',
      };
      const resp = await controlPage({ companyIds }, params);
      const arrTemp = resp.records || [];
      this.peopleList = arrTemp.map((item) => ({ ...item, label: item.unifyName, value: `${item.unifyId}||${item.unifyName}||UNIFY_USER||${item.companyId || ''}||${item.companyName || ''}` }));
      const transferValue = [];
      this.transferValue.forEach((item) => {
        if (this.peopleList.find((key) => key.value === item)) {
          transferValue.push(item);
        }
      });
      this.transferValue = transferValue;
    },
  },
};
</script>
